import { getUsageQuery } from "../../graphql/queries";
import { GetUsageQuery, GetUsageQueryVariables } from "../../graphql/types";
import { fetchGraphql, useGraphql } from "./graphqlClient";

export type Usage = NonNullable<GetUsageQuery["self"]>["usage"];

// export async function fetchUsage(): Promise<Usage | null> {
//     const result = await fetchGraphql<GetUsageQuery, GetUsageQueryVariables>("GetUsage", getUsageQuery, {}, true);
//     return result.data?.self?.usage ?? null;
// }

let cachedUsage: GetUsageQuery|null = null;

export function useUsage(): { result: GetUsageQuery | null } {
    const hasCache = !!cachedUsage;
    const result = useGraphql<GetUsageQuery, GetUsageQueryVariables>("GetUsage", getUsageQuery, {}, { skip: hasCache });
    if (result.result) cachedUsage = result.result;
    return result.result ? result : { result: cachedUsage };
}
